//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LazyFormRow from "@/components/common/LazyFormRow/index";
import CommonForm from "@/components/common/CommonForm";
import {mapGetters} from "vuex";
import componentWithForm from "@/mixins/componentWithForm";
import FormRecaptca from "@/components/common/LazyFormRow/components/components/FormRecaptca";
export default {
    name: "OrderTrackerPage",
    components: {FormRecaptca, CommonForm, LazyFormRow},
    mixins: [componentWithForm],
    data() {
        return {
            formId: 'order_tracking_form',
            showError: false,
            showInfo: false,
        }
    },
    computed: {
        ...mapGetters({
            isGuest: 'user/isGuest',
        }),
    },
    methods: {
        successSubmit(response) {
            this.showError = false;
            this.$store.commit(`cart/${types.SET_ORDER_TRACKER}`, response.OrderTrackingForm);
            this.$router.push(this.localePath('/order-view'))
        },
        errorSubmit(error) {
            if (error?.OrderTrackingForm?.commonError) {
                this.showError = true;
            }
            if (error?.OrderTrackingForm?.token) {
                this.hasCaptchaError = true;
                this.$store.commit(`forms/${ types.UPDATE_FORM_VALUE_BY_ID }`, {
                    formId: this.formId,
                    fieldName: 'token_type',
                    value: 'v2'
                });
            }
            if (!error) {
                this.hasCaptchaError = true;
            }
        },
        toggleInfo() {
            this.showInfo = !this.showInfo;
        },
        closeInfo() {
            this.showInfo = false
        }
    }
}
